module.exports = __webpack_public_path__ + "img/404.43966fab.jpg";